module.exports = __webpack_public_path__ + "f2477f9cb087e9de367dd7a0de909274.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-30.png
// module id = 2609
// module chunks = 0